// extracted by mini-css-extract-plugin
export var fb = "event-post-module--fb--1192a";
export var ig = "event-post-module--ig--9aa56";
export var link = "event-post-module--link--8a3ff";
export var mc = "event-post-module--mc--6d77a";
export var sc = "event-post-module--sc--02640";